import { useInView } from 'react-intersection-observer'
import { useMediaQuery } from 'usehooks-ts'
import { SuggestionsDrawer } from '@components/SuggestedProductsDrawer/SuggestedProductsDrawer'
import { useCart } from '@velasca/hooks/use-cart'
import { useSliderProducts } from '@velasca/hooks/use-slider-products'
import { Modal } from '@velasca/ui/modal'
import { transformProductsSliderData } from '@velasca/utils/transform-products-slider-data'
import { Container, StyledProductsSlider } from './ShopTheLookModal.styles'
import type { ShopTheLookModalProps } from './ShopTheLookModal.types'

export const ShopTheLookModal = ({
  drawerTitle,
  title,
  subtitle,
  children,
  productIDs,
  isOpen,
  onClose,
}: ShopTheLookModalProps) => {
  const { isDrawerOpen } = useCart()
  const isSmallerThan768px = useMediaQuery('(max-width: 767px)')

  const [ref, isInView] = useInView({
    rootMargin: `100px 0px 100px 0px`,
    triggerOnce: true,
  })

  const { loading, products } = useSliderProducts(productIDs, !isInView)
  const transformedProducts = transformProductsSliderData(products)

  if (!onClose) {
    return children
  }

  return (
    <>
      <Container ref={ref}>{children}</Container>

      {productIDs &&
        isInView &&
        (isSmallerThan768px ? (
          <SuggestionsDrawer
            title={drawerTitle}
            isOpen={isOpen}
            products={transformedProducts}
            loading={loading}
            productIDs={productIDs}
            onClose={() => {
              onClose(false)
            }}
          />
        ) : (
          !isDrawerOpen && (
            <Modal
              open={isOpen}
              onOpenChange={(...args) => {
                onClose(...args)
              }}
            >
              <StyledProductsSlider
                showProductType
                loading={loading}
                sliderStyles={{ padding: '2.5rem' }}
                loadingSlides={productIDs.length}
                products={transformedProducts}
                title={title}
                subTitle={subtitle}
                slidesSize="dynamic-size"
                shouldOpenCartDrawerOnAddToCart={false}
              />
            </Modal>
          )
        ))}
    </>
  )
}
